export class NativeStreamAggregationServing {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "copies",
            "baseName": "copies",
            "type": "number",
            "format": ""
        },
        {
            "name": "keySeparator",
            "baseName": "keySeparator",
            "type": "string",
            "format": ""
        },
        {
            "name": "freshness",
            "baseName": "freshness",
            "type": "NativeStreamAggregationServingFreshness",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationServing.attributeTypeMap;
    }
    constructor() {
    }
}
